/**
 * Format a duration in seconds to HH:MM:SS display string.
 */
export function formatDuration(seconds: number): string {
  if (!seconds || seconds < 0) return '00:00:00';
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Convert seconds to decimal hours (e.g. 5400 -> 1.50).
 */
export function secondsToHours(seconds: number): number {
  if (!seconds || seconds < 0) return 0;
  return Math.round((seconds / 3600) * 100) / 100;
}

/**
 * Format a currency amount for timetrack display.
 */
export function formatTimetrackCurrency(amount: number, currency = 'ZAR'): string {
  const symbols: Record<string, string> = { ZAR: 'R', USD: '$', EUR: '\u20AC', GBP: '\u00A3' };
  const symbol = symbols[currency] || 'R';
  return `${symbol}${amount.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
